import { Component, OnInit } from '@angular/core';
import { SearchContent } from './search-content.model';
import { Router } from '@angular/router';
import { SearchContentsValues } from './search-content-values';
import { SearchService } from '@app/services/search-service';
import { Insights } from '@app/services/insights.service';
import { InsightsApiService } from '@app/services/insights-api.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InsightsKeyword, InsightsKeywordState } from '@app/store/insights/state';
import * as fromActions from '@app/store/insights/actions';

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
    searchTerm: string = "";
    submitClicked: boolean = false;
    searchContents: SearchContent[] = [];

    constructor(private router: Router, private searchService: SearchService, private insights: Insights, private insightsApi: InsightsApiService, private store: Store<InsightsKeywordState>) {}

    ngOnInit(): void {
        this.populateSearchContents();
    }

    isSearchTermEmpty(): boolean {
        return !this.searchTerm.trim();
    }

    onSubmit() {
        this.submitClicked = true;

        if (this.isSearchTermEmpty()) {
            return;
        }

        // Send user search input to Azure App Insights for tracking purposes
        this.insights.trackSearch(this.searchTerm);

        // Save search keyword into database.
        this.addKeyword(this.searchTerm);
        
        let foundContent = this.findPage(this.searchContents, this.searchTerm);

        // Send content to serivce
        this.searchService.setSearchResult(foundContent as any);

        this.submitClicked = false;

        this.goToSearchResults();
    }

    /**
     * Dispatch an action to save user input keyword.
     * 
     * @param keyword the search term
     */
    addKeyword(keyword: string) {
        this.store.dispatch(fromActions.addInsightsKeyword({keyword: keyword}));
    }

    private goToSearchResults() {
        this.router.navigate(["/search-results"]);
    }

    /**
     * Search for pages matching one or more keyword.
     *
     * @param searchContents The list of pages and keywords
     * @param searchTerm The user input search term
     * @returns list of found pages
     */
    public findPage(
        searchContents: SearchContent[],
        searchTerm: string,
    ): SearchContent[] {
        const searchWords = searchTerm.toLowerCase().split(" ");
        return searchContents.filter((content) => {
            const keywords = content.keywords.toLowerCase();
            return searchWords.every((word) => {
                return keywords.includes(word);
            });
        });
    }

    private populateSearchContents() {
        this.searchContents = SearchContentsValues;
    }
}
